import { createSelector } from 'reselect';
import { selectSearchTerm, selectItemUpdates } from '../../../selectors';
import _ from 'lodash';
import search from '../../../reducers/search';

const selectNewFeatureGroup = (state) => state.newFeatureGroup;

const selectPendingFeatureGroups = (state) => selectNewFeatureGroup(state).newFeatureGroups;

export { selectSearchTerm };

export const getPendingFeatureGroups = createSelector(
  [selectPendingFeatureGroups],
  (featureGroups) => {
    return featureGroups;
  }
);

export const getFilteredPendingFeatureGroups = createSelector(
  [selectPendingFeatureGroups, selectSearchTerm],
  (featureGroups, term) => {
    let _term = _.trim(term.toLowerCase());
    if(_term.length > 0) {
      return featureGroups.filter(f => f.name.toLowerCase().includes(_term));
    }
    return featureGroups;
  }
)
